import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import hide from "../../assets/images/hide.svg";
import show from "../../assets/images/show.svg";
import Header from "../../components/Header";



const Login: React.FC = () => {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
      await login(email, password);
      if (rememberMe) {
        localStorage.setItem("rememberMe", "true");
        localStorage.setItem("rememberMeEmail", email); // Salveaza email-ul
      } else {
        localStorage.removeItem("rememberMe");
        localStorage.removeItem("rememberMeEmail");
      }
    
      navigate("/webmaster/dashboard"); // Redirectionare dupa login
   
  };

  useEffect(() => {
    const rememberedEmail = localStorage.getItem("rememberMeEmail");
    if (rememberedEmail) {
      setEmail(rememberedEmail);
      setRememberMe(true);
    }
  }, []);

  return (
    <div className="content">
        <Header />
    <div className="login-container">
      <div className="container">
        <div className="login-box">
          
          <h2>Intră în contul tău</h2>

          <form onSubmit={handleSubmit} className="login-form">
            <input
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className="password-container">
              <input
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Parolă"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
              type="button"
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            >
              {isPasswordVisible ? (<img className="hide-icon" src={hide} />) : (<img className="show-icon" src={show} />) }
            </button>
            </div>

            <div className="remember-me">
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="rememberMe">Ține-mă minte</label>
            </div>

            {error && <p className="error-message">{error}</p>}

            <button type="submit" className="login-button">
              Intră în cont <span className="login-arrow">→</span>
            </button>
          </form>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Login;
